document.addEventListener("DOMContentLoaded", function () {
  // === URL PARAMETER CAPTURE & FORWARDING ===
  const params = new URLSearchParams(window.location.search);

  // Save params in sessionStorage for navigation persistence
  if (params.toString()) {
    sessionStorage.setItem("shopify_params", params.toString());
  }

  // Append stored params ONLY to buy-button links
  const storedParams = sessionStorage.getItem("shopify_params");
  if (storedParams) {
    const extraParams = new URLSearchParams(storedParams);

    document.querySelectorAll("a.buy-button").forEach(link => {
      const url = new URL(link.href, window.location.origin);

      // Merge new params into existing ones
      extraParams.forEach((value, key) => {
        url.searchParams.set(key, value); // overrides if already exists
      });

      link.href = url.toString();
    });
  }

  // CTA Button
  document.querySelectorAll(".buynow-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.getElementById("limited-offer").scrollIntoView({
        behavior: "smooth",
      });
    });
  });

  // Testimonials
  const cards = document.querySelectorAll(".testimonial-card");
  cards.forEach((card, index) => {
    card.style.opacity = "0";
    card.style.transform = "translateY(20px)";
    setTimeout(() => {
      card.style.transition = "all 0.6s ease";
      card.style.opacity = "1";
      card.style.transform = "translateY(0)";
    }, index * 200);
  });

  // Limited Time Offer
  const fill = document.querySelector(".progress-fill");
  fill.style.width = "0%";
  setTimeout(() => {
    fill.style.transition = "width 1.5s cubic-bezier(0.4,0,0.2,1)";
    fill.style.width = "90%";
  }, 200);

  // FAQ Accordion
  const questions = document.querySelectorAll(".faq-question");

  questions.forEach((question) => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;

      questions.forEach((q) => {
        if (q !== question) {
          q.classList.remove("active");
          q.nextElementSibling.classList.remove("open");
        }
      });

      question.classList.toggle("active");
      answer.classList.toggle("open");
    });
  });
});

// Vimeo Player
function playVideo(videoNumber, hashNumber) {
  if (!videoNumber) return;
  if (!hashNumber) return;

  lity(`https://player.vimeo.com/video/${videoNumber}?h=${hashNumber}&badge=0&autoplay=1&player_id=0&app_id=58479`);
}

// Random Range
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Countdown Timer
function startCountdown(hours, minutes, seconds, prefix) {
  let total = hours * 3600 + minutes * 60 + seconds;

  const ticker = () => {
    const hrs = Math.floor(total / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;

    document.getElementById(prefix + "-hours").textContent = String(
      hrs
    ).padStart(2, "0");
    document.getElementById(prefix + "-minutes").textContent = String(
      mins
    ).padStart(2, "0");
    document.getElementById(prefix + "-seconds").textContent = String(
      secs
    ).padStart(2, "0");

    if (total > 0) {
      total--;
      setTimeout(ticker, 1000);
    } else {
      // reload page if time expire
      location.reload();
    }
  };

  ticker();
}

// Start 1-hour countdown
const randomMinutes = getRandomInt(0, 60);
const randomSeconds = getRandomInt(0, 60);
startCountdown(1, 0, 5, "hero");
startCountdown(1, 0, 5, "limited");

jQuery(document).ready(function ($) {
  $(".chart-slides").slick({
    dots: true,
    speed: 500,
    slidesToShow: 1,
  });
});
